import { buildNavigationUrl } from "../../util/buildNavigationUrl";
const parseWarehouseItemId = value => {
  const warehouseItemId = Number(value);
  return Number.isInteger(warehouseItemId) && warehouseItemId > 0
    ? warehouseItemId
    : null;
};

const getWarehouseItemIdFromValues = values =>
  parseWarehouseItemId(values?.item?.id ?? values?.id);

const getWarehouseItemDetailsUrl = (values, search = "") => {
  const warehouseItemId = getWarehouseItemIdFromValues(values);
  if (warehouseItemId == null) return "/warehouse";

  const queryParams = new URLSearchParams(search);

  return buildNavigationUrl(`${warehouseItemId}/details`, queryParams);
};

const buildWarehouseNavigationTargetUrl = ({
  activeSubPage = "details",
  listContext = {},
  recordId,
  status = "all",
} = {}) => {
  const query = new URLSearchParams(listContext.locationSearch || "");
  if (status === "all") query.delete("status");
  else if (status) query.set("status", status);
  return buildNavigationUrl(`/warehouse/${recordId}/${activeSubPage}`, query);
};

export {
  buildWarehouseNavigationTargetUrl,
  getWarehouseItemDetailsUrl,
  getWarehouseItemIdFromValues,
  parseWarehouseItemId,
};
